export const accountSections = [
  { label: 'My profile', route: 'settings-profile' },
  { label: 'Company settings', route: 'settings-branding' },
  { label: 'Team', route: 'settings-team' },
  { label: 'Billing & usage', route: 'settings-billing' },
  { label: 'Integrations', route: 'settings-integrations' }
]
